import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cf53876c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cf53876c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf53876c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf53876c')) {
      api.createRecord('cf53876c', component.options)
    } else {
      api.reload('cf53876c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cf53876c&scoped=true", function () {
      api.rerender('cf53876c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/ads/advList/createAdv/index.vue"
export default component.exports